module.exports = __webpack_public_path__ + "4f934d756d2785f932979db46b82b904.png";